export default {
  // Header
  about: 'حول',
  projects: 'المشاريع',
  contact: 'اتصل',
  
  // Hero Section
  heroTitle: 'تجارب ألعاب غامرة',
  heroTitleHighlight: 'من الشرق الأوسط.',
  heroDescription: 'ديب كويست تصنع ألعاباً مبتكرة تأسر اللاعبين في جميع أنحاء العالم بتقنية متطورة وسرد قصصي مميز.',
  
  // About Section
  aboutTitle: 'ديب كويست',
  aboutTitleSuffix: '، استوديو ألعاب رائد',
  aboutDescription: 'نصنع تجارب ألعاب غامرة تمزج بين السرد القصصي الغني والتكنولوجيا المتطورة. شغفنا هو خلق عوالم تأسر اللاعبين عالمياً، وتقديم وجهات نظر فريدة وأسلوب لعب مبتكر يدفع حدود الترفيه التفاعلي.',
  
  // Projects Section
  featuredGame: 'مميز',
  game: 'لعبة',
  oasisRichman: 'أويسيس ريتشمان',
  gameDescription: 'اختبر أفضل لعبة استراتيجية اجتماعية على الهاتف المحمول بأسلوب المونوبولي في واحة صحراوية نابضة بالحياة. ابنِ إمبراطوريتك، تاجر بالعقارات، وتنافس مع الأصدقاء في هذا المزيج المثير من آليات ألعاب الطاولة الكلاسيكية وألعاب الهاتف المحمول الحديثة.',
  strategicGameplay: 'أسلوب لعب استراتيجي',
  strategicGameplayDesc: 'أتقن فن التجارة العقارية وإدارة الموارد',
  socialExperience: 'تجربة اجتماعية',
  socialExperienceDesc: 'تواصل وتنافس مع لاعبين من جميع أنحاء العالم',
  richRewards: 'مكافآت غنية',
  richRewardsDesc: 'افتح الإنجازات واجمع العناصر الحصرية',
  playNow: 'العب الآن!',
  
  // Contact Section
  contactTitle: 'اتصل بـ',
  contactTitleHighlight: 'DeepQuest',
  contactTitleSuffix: 'لمعرفة المزيد',
  contactDescription: 'هل أنت مستعد لتحويل رؤيتك إلى واقع؟ دعنا نناقش كيف يمكن لحلول الألعاب المبتكرة لدينا أن ترتقي بمشروعك القادم.',
  yourName: 'اسمك',
  yourEmail: 'بريدك الإلكتروني',
  yourMessage: 'رسالتك',
  sendMessage: 'إرسال الرسالة',
  sending: 'جارٍ الإرسال...',
  messageSent: 'تم إرسال الرسالة بنجاح!',
  messageFailed: 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.',
  fillAllFields: 'يرجى ملء جميع الحقول.',
  
  // Common
  learnMore: 'اعرف المزيد',
  
  // Language
  language: 'اللغة',
  english: 'English',
  arabic: 'العربية'
};
